<template>
	<main id="form">
		<form autocomplete="off" v-on:submit.self.stop.prevent="validateForm()">
			<h2>{{this.properties && getLabel(this.properties.title)}}</h2>
			<ul v-if="properties.fields">
				<!--<li>
					<select_checkbox_input v-on:validateField="validateExtraInput" v-bind:params="getParams('schoolName')" v-bind:oldValue="oldValue['schoolName']" v-bind:lang="lang"></select_checkbox_input>
				</li>-->
				<li>
					<select_checkbox_autocomplete_input v-on:validateField="validateExtraInput" v-bind:params="getParams('schoolName')" v-bind:oldValue="oldValue['schoolName']" v-bind:lang="lang"></select_checkbox_autocomplete_input>
				</li>
				<!-- If name_school choice is other -->
				<li v-if="this.display.schoolName === 'autre école'">
					<text_input v-on:validateField="validateField" v-bind:params="getParams('other_school')" v-bind:oldValue="oldValue['other_school']" v-bind:lang="lang"></text_input>
				</li>
				<li>
					<radio_input v-on:validateField="validateExtraInput" v-bind:params="getParams('diploma')" v-bind:oldValue="oldValue['diploma']" v-bind:lang="lang"></radio_input>
				</li>
				<!-- <li>
					<radio_input v-on:validateField="validateExtraInput" v-bind:params="getParams('double_diploma')" v-bind:oldValue="oldValue['double_diploma']" v-bind:lang="lang"></radio_input>
				</li> -->
				<!-- <li v-if="this.display.double_diploma== 'yes'">
					<text_input v-on:validateField="validateField" v-bind:params="getParams('double_diploma_school')" v-bind:oldValue="oldValue['double_diploma_school']" v-bind:lang="lang"></text_input>
				</li> -->
				<!-- <li>
					<pools_radio_input v-on:validateField="validateExtraInput"  v-bind:params="getParams('associative_school')" v-bind:oldValue="oldValue['associative_school']" v-bind:lang="lang"></pools_radio_input>
				</li> -->
				<!-- <li>
					<text_input v-on:validateField="validateField" v-bind:params="getParams('associative_school')" v-bind:oldValue="oldValue['associative_school']" v-bind:lang="lang"></text_input>
				</li> -->
			</ul>
			<button v-bind:class="isActive ? 'selected' : ''" type="submit">{{getLabel(fields.next)}}</button>
		</form>
	</main>
</template>

<script>
//Input components
import radio_input from '@/components/candidate_forms/radio_input.vue';
import select_checkbox_input from '@/components/candidate_forms/select_checkbox_input.vue';
import select_checkbox_autocomplete_input from '@/components/candidate_forms/select_checkbox_autocomplete_input.vue';
import text_input from '@/components/candidate_forms/text_input.vue';
import pools_radio_input from '@/components/candidate_forms/pools_radio_input.vue';

import lib from '@/libs/main.js';
import componentTools from '@/libs/componentTools.js';

function checkForm(scope){
	if(!scope.properties || !scope	|| !Array.isArray(scope.properties.fields)) return false;
	if((scope.display.schoolName === 'autre école') && !scope.answer['other_school']) return false;
	// if((scope.display.double_diploma === 'yes') && !scope.answer['double_diploma_school']) return false;
	return ['schoolName','schoolStr', 'diploma'/*, 'double_diploma'*/].every(e => scope.answer[e]);
}

function remove_nameSchool(val){
	if(val !== 'autre école') delete this.answer["other_school"];
}

function remove_curriculum_followed(val){
	if(val != "business") delete this.answer["diploma_business"];
	if(val != "engineer") delete this.answer["diploma_engineer"];
	if(val != "university") delete this.answer["diploma_university"];
}
function remove_double_diploma(val){
	if(val != "yes") ['double_diploma_nameSchool', 'double_diploma_curriculum_followed', 'double_diploma_engineer', 'double_diploma_business', 'double_diploma_university'].forEach(k => delete this.answer[k]);

}
function remove_double_diploma_curriculum_followed(val){
	if(val != "business") delete this.answer["double_diploma_business"];
	if(val != "engineer") delete this.answer["double_diploma_engineer"];
	if(val != "university") delete this.answer["double_diploma_university"];
}

export default {
	name: 'academic_careerTpl',
	data() {
		return {
			answer : {},
			oldValue : {},
			isActive : false,
			display : {
				schoolName: false,
				curriculum_followed: false,
				// double_diploma: false,
				// double_diploma_curriculum_followed: false,
				schoolStr : false,
				// associative_school: false,
				// double_diploma_school: false
			},
			fields : {
				next : {
					fr : 'Valider',
					en : 'Next'
				}
			},
		}
	},
	props : ['currentSession', 'properties', 'lang', 'templateIndex'],
	components : {
		radio_input, select_checkbox_input,select_checkbox_autocomplete_input, pools_radio_input, text_input
	},
	methods : {
		validateForm : function() {
			if(!checkForm(this)) return;
			remove_nameSchool.call(this, this.answer['schoolName']);
			remove_curriculum_followed.call(this, this.answer['curriculum_followed']);
			// remove_double_diploma.call(this, this.answer['double_diploma']);
			// remove_double_diploma_curriculum_followed.call(this, this.answer['double_diploma_curriculum_followed']);
			let out = {};
			this.properties.fields.forEach( field => {
				if(this.answer[field.params.name]) out[field.params.name] = this.answer[field.params.name];
			});
			if(this.answer['schoolStr']) out['schoolStr'] = this.answer['schoolStr'];
			this.$emit('validateStep', this.$options.name, out);
		},
		validateField : function(name, value) {
			this.answer[name] = value;
			this.isActive = checkForm(this);
		},
		validateExtraInput : function(name, value) {
			const params = this.getParams(name);
			var answer = params && params.options && params.options.find(e => e.value == value); // Radio
			if(typeof answer == "undefined") answer = params && params.choices && params.choices.find(e => e.value == value); // Select_checkbox
			if(typeof this.display[name] != "undefined" && typeof value != "undefined") this.display[name] = answer && value;
			this.answer[name] = answer && value;
			if(name == "schoolName"){
				if(!value){
					this.answer['schoolStr'] = '';
					this.answer['schoolName'] = '';
					this.display['schoolStr'] = '';
					this.display['schoolName'] = '';
				}else{
					var elemt = params.choices.find(e => e.label == value);
					var schoolStr = params.choices.find(e => e.label == value).label;
					if(elemt.label){
						this.answer['schoolStr'] = elemt.label;
						this.answer['schoolName'] = elemt.label;
						this.display['schoolStr'] = elemt.label;
						this.display['schoolName'] = elemt.label;
					}
				}

			}
			this.isActive = checkForm(this);
		},
		getParams : function(name){
			return this.properties.fields.find(x => x.params && x.params.name == name).params;
		},
		getLabel : componentTools.getLabel
	},
	watch : {
		currentSession : {
			handler : function(val){
				let candidateTplRes = val.stepsResults && val.stepsResults[this.$options.name + '_' + this.templateIndex];
				if(!candidateTplRes){
					Object.keys(this.answer).forEach(k => this.$set(this.oldValue, k, null)); //cf vue reactivity for binded object properties
					this.answer = {};
				}
			},
			deep : true,
		},
		"display.nameSchool" : remove_nameSchool,
		"display.curriculum_followed" : remove_curriculum_followed,
		// "display.double_diploma" : remove_double_diploma,
		// "display.double_diploma_curriculum_followed" : remove_double_diploma_curriculum_followed,
	},
	created : function(){
		componentTools.created.call(this);
		const oldRes = this.currentSession.stepsResults[this.$options.name + '_' + this.templateIndex];
		if(oldRes) this.oldValue = oldRes;
		if(!this.oldValue['schoolName'] && this.properties && this.properties.fields) { //Try to preselect school name according to event name
			const fieldsConf = this.properties.fields.find(e => e.params.name == 'schoolName');
			const eventName = this.currentSession.event.name.toLowerCase().split(/\s|[-_(),+/.]/).filter(e => e.length);
			let matches = [];
			fieldsConf.params.choices.forEach(choice => {
				const parts = componentTools.getLabel(choice.label).toLowerCase().split(/\s|[-_(),+/.]/).filter(e => e.length);
				const score = {perfect : 0};
				for(let i = 0; i < parts.length; ++i) {
					if(parts[i].length <= 2) continue;
					if(eventName.find(e => e.length > 2 && e === parts[i])) score.perfect++;
				}
				if(score.perfect > 0) matches.push({value : choice.label, score : score.perfect });
			});
			matches.sort( (a,b) => b.score - a.score);
			if(matches.length && matches[0].score >= 1) this.oldValue['schoolName'] = [matches[0].label];
		}
	},
	mounted : componentTools.mounted
};
</script>

<style lang="less">
@import '../../assets/less/conf.import.less';
#form ul{
	li{
		position: relative;
		margin-top: 3%;
		margin-bottom: 3%;
		label{
			position: absolute;
			left: 0;
			margin-top: 2%;
			max-width: 40%;
			text-align: left;
		}
		input{
			&[type="date"]{
				width: 40%;
				margin-left: 60%;
			}
			&[type="checkbox"], &[type="radio"]{
				display: inline-block;
			}
			&[type="text"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="email"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="number"]{
				width: 50%;
				margin-left: 50%;
			}
			&[type="tel"]{
				width: 50%;
				margin-left: 50%;
			}
		}
	}
}

.pools input[type="radio"]{
	display: none !important;
}
.pools {
	padding-bottom: 5%;
	display: flex;
	justify-content: center;

}
</style>



// WEBPACK FOOTER //
// src/components/ey/academic_career.vue